import { formatFaxNumberInput } from '@/shared/lib/formatters';

export function formatFaxNumberInFaxDocument(markdown: string): string {
  return markdown.replace(
    /^[ \t]*(?:\*\*)?Fax:(?:\*\*)?[ \t]*(.*?)(?:\*\*)?[ \t]*$/gm,
    (_line, value: string) => {
      const formattedValue = formatFaxNumberInput(value);
      return formattedValue === '' ? '**Fax:**' : `**Fax:** ${formattedValue}`;
    }
  );
}
